import React from 'react';
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import { CheckCircle, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const GuestInformationSuccess = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <CheckCircle color="success" sx={{ fontSize: 80, mb: 3 }} />
        
        <Typography variant="h4" gutterBottom color="success.main">
          Information Submitted Successfully!
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
          Thank you for providing your information
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          Your guest information has been successfully submitted and processed. 
          You will receive a confirmation email shortly.
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          We look forward to welcoming you to your stay!
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            size="large"
            startIcon={<Home />}
            onClick={() => navigate('/')}
          >
            Return to Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default GuestInformationSuccess;
